(() => {
  new Swiper(".timeline-entries__slider", {
    slidesPerView: 1,
    spaceBetween: 25,
    autoplay: {
        delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next-timeline-slider",
      prevEl: ".swiper-button-prev-timeline-slider",
    },       
  });
})();
